import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { TRANSLATIONS } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("eram_lang") || "en");

  useEffect(() => {
    localStorage.setItem("eram_lang", lang);
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "en" ? "ar" : "en")), []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = TRANSLATIONS[lang];
      for (const p of parts) {
        node = node?.[p];
      }
      return node ?? path;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
